import type { AuthMethod, User, UserStatus } from "../../../api/types";

/**
 * Fallbacks for `User.authMethod`/`User.status` being OPTIONAL on the real
 * wire contract as of ADR-0037 PR-2b (`GET/POST/PATCH /api/users` doesn't
 * populate them yet — see the doc comment on `User` in api/types.ts). Kept in
 * one place so UsersPage and CreateUserModal can't drift on what "missing"
 * means.
 */

/** A missing `authMethod` means "password" — every pre-ADR-0037 account, and
 * the server's own documented default for the field once it exists. */
export function resolveAuthMethod(user: User): AuthMethod {
  return user.authMethod ?? "password";
}

/** A missing `status` is derived from the boolean `active` gate — NEVER
 * assumed `"invited"`, which would misrepresent a merely-inactive account as
 * a pending SSO invite. */
export function resolveStatus(user: User): UserStatus {
  return user.status ?? (user.active ? "active" : "inactive");
}
